<template>
    <div id="formModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Dispute Claim For Medical Treatment (1009)</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>   
                </div>
                <div class="modal-body">
                    <form v-if="model" novalidate>
                        <general-page v-if="page === 0" v-bind:model="model.general"></general-page>
                        <employee-page v-if="page === 1" v-bind:model="model.employee" v-bind:states="states"></employee-page>
                        <employee-attorney-page v-if="page === 2" v-bind:model="model.employeeAttorney" v-bind:states="states" v-bind:contacts="contacts"></employee-attorney-page>
                        <employer-page v-if="page === 3" v-bind:model="model.employer" v-bind:states="states"></employer-page>
                        <insurer-admin-page v-if="page === 4" v-bind:model="model.insurer" v-bind:states="states"></insurer-admin-page>
                        <provider-page v-if="page === 5" v-bind:model="model.provider" v-bind:states="states"></provider-page>
                        <insurer-attorney-page v-if="page === 6" v-bind:model="model.insurerAttorney" v-bind:states="states"  v-bind:contacts="contacts"></insurer-attorney-page>
                        <details-page v-if="page === 7" v-bind:details.sync="model.details"></details-page>
                        <associations-page v-if="page === lastPage" :authorizations="authorizations" @associate="onAssociate"></associations-page>
                        <!-- <review-page v-if="page === lastPage" v-bind:model="model"></review-page> -->
                    </form>
                </div>
                <div class="modal-footer justify-content-between">
                    <div>
                        <button v-if="page !== lastPage" class="btn btn-primary" @click="save">
                            <i class="fas fa-save"></i>
                        </button>
                    </div>
                    <div>
                        <button v-if="page > 0" class="btn btn-secondary" @click="previous"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</button>
                        <button v-if="page < lastPage" class="btn btn-secondary" @click="next">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></button>
                        <button v-if="page === lastPage" class="btn btn-primary" @click="generate" :disabled="!selectedAuthorizations.length">Generate</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GeneralPage from './Form1009GeneralComponent.vue';
import EmployeePage from './Form1009EmployeeComponent.vue';
import EmployeeAttorneyPage from './Form1009EmployeeAttorneyComponent.vue';
import EmployerPage from './Form1009EmployerComponent.vue';
import InsurerAdminPage from './Form1009InsurerAdminComponent.vue';
import ProviderPage from './Form1009ProviderComponent.vue';
import InsurerAttorneyPage from './Form1009InsurerAttorneyComponent.vue';
import DetailsPage from './Form1009DetailsComponent.vue';
import AssociationsPage from './Form1009AssociationComponent.vue';
// import ReviewPage from './Form1009ReviewComponent.vue';

export default {
    components: {
        GeneralPage,
        EmployeePage,
        EmployeeAttorneyPage,
        EmployerPage,
        InsurerAdminPage,
        ProviderPage,
        InsurerAttorneyPage,
        DetailsPage,
        AssociationsPage
        // ReviewPage,
    },
    props: {
        claimId: Number,
    },
    data() {
        return {
            firstPage: 0,
            lastPage: 8,
            page: 0,
            model: Object,
            states: [],
            contacts: [],
            authorizations: []
        }
    },
    computed: {
        selectedAuthorizations: function () {
            return this.authorizations.filter(e => e.selected);
        }
    },
    methods: {
        show: function(documentId) {

            // NOTE: documentId is only set if we initiate the dispute from a
            //       particular document in the authorization documents section

            // reset data properties
            this.page = 0;
            this.model = null;
            this.documents = [];
            this.states = [];
            this.contacts = [];
            this.authorizations = [];

            axios.get('/ajax/provider/claims/' + this.claimId + '/disputes/new')
                .then((response) => {
                    this.model = response.data.model;
                    this.states = response.data.states;
                    this.contacts = response.data.contacts;
                    this.authorizations = response.data.authorizations.map(e => { this.$set(e, 'selected', e.id === documentId); return e; });
                    $('#formModal').modal('show');
                })
                .catch((error) => {
                    console.log(error.response.data);
                    // TODO: display error
                });            
        },
        hide: function() {
            $('#formModal').modal('hide');
        },
        save: function() {
            axios.put('/ajax/provider/claims/' + this.claimId + '/disputes', {
                'model': this.model
            })
            .then(response => {
                
            })
            .catch(error => {
                let title = error.response.data.title;
                let message = error.response.data.message;
                let level = error.response.data.level;
                toastr[level](message, title, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });                       
            });
        },
        next: function() {
            if (this.page < this.lastPage) { this.page++; }
        },
        previous: function() {
            if (this.page > this.firstPage) { this.page--; }
        },
        generate: function() {

            this.hide();
            $('#spinner').modal('show');

            var self = this;
            axios.post('/ajax/provider/claims/' + this.claimId + '/disputes/generate', {
                'model': this.model,
                'authorizations': this.selectedAuthorizations.map(e => e.id)
            })
            .then((response) => {                                            
                $('#spinner').modal('hide');
                let title = response.data.title;
                let message = response.data.message;
                let level = response.data.level;
                toastr[level](message, title, {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});                 
            })
            .catch((error) => {
                self.errors = error.response.data.errors;

                // if error comes back to quickly the spinner will not go away; handling with timeout
                window.setTimeout(function(){
                    $('#spinner').modal('hide'); 
                }, 1000);

                toastr[error.response.data.level](
                    error.response.data.message, 
                    error.response.data.title, 
                    { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });                   
            });
        },
        onAssociate: function (document, checked) {
            document.selected = checked;
        }
    },
    created() {
        eventHub.$on('show-form-1009', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-form-1009');
    },  
}
</script>

<style>
    .chev-pos {
        position: relative;
        top: -3px;
        left: -3px;        
    }
</style>


